const CHECKED_AT = "2026-08-24";
const REVIEW_STATE = "needs-maintainer-review";

export const senateProfileSources = Object.freeze({
  "house-history-edward-markey": {
    id: "house-history-edward-markey",
    label: "Edward Markey congressional biography",
    publisher: "U.S. House of Representatives: History, Art & Archives",
    kind: "official-government",
    authority: "primary",
    url: "https://history.house.gov/people/detail/17493",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "senate-office-edward-markey": {
    id: "senate-office-edward-markey",
    label: "Senator Edward Markey official office",
    publisher: "United States Senate",
    kind: "official-government",
    authority: "primary",
    url: "https://www.markey.senate.gov/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "campaign-edward-markey": {
    id: "campaign-edward-markey",
    label: "Ed Markey for Senate",
    publisher: "The Markey Committee",
    kind: "campaign-controlled",
    authority: "self-reported",
    url: "https://www.edmarkey.com/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-edward-markey-2026": {
    id: "fec-edward-markey-2026",
    label: "Edward Markey 2026 candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/S4MA00028/?cycle=2026",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-federal-elections-2020": {
    id: "fec-federal-elections-2020",
    label: "Federal Elections 2020",
    publisher: "Federal Election Commission",
    kind: "official-election",
    authority: "official-results-compilation",
    url: "https://www.fec.gov/resources/cms-content/documents/federalelections2020.pdf",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-federal-elections-2014": {
    id: "fec-federal-elections-2014",
    label: "Federal Elections 2014",
    publisher: "Federal Election Commission",
    kind: "official-election",
    authority: "official-results-compilation",
    url: "https://www.fec.gov/resources/cms-content/documents/federalelections2014.pdf",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "house-history-seth-moulton": {
    id: "house-history-seth-moulton",
    label: "Seth Moulton congressional biography",
    publisher: "U.S. House of Representatives: History, Art & Archives",
    kind: "official-government",
    authority: "primary",
    url: "https://history.house.gov/People/Listing/M/MOULTON,-Seth-(M001196)/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "house-office-seth-moulton": {
    id: "house-office-seth-moulton",
    label: "Representative Seth Moulton official office",
    publisher: "U.S. House of Representatives",
    kind: "official-government",
    authority: "primary",
    url: "https://moulton.house.gov/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "campaign-seth-moulton": {
    id: "campaign-seth-moulton",
    label: "Seth Moulton for Massachusetts",
    publisher: "Seth for Massachusetts, Inc.",
    kind: "campaign-controlled",
    authority: "self-reported",
    url: "https://sethmoulton.com/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-seth-moulton-senate-2026": {
    id: "fec-seth-moulton-senate-2026",
    label: "Seth Moulton 2026 Senate candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/S6MA00296/?cycle=2026",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-seth-moulton-house": {
    id: "fec-seth-moulton-house",
    label: "Seth Moulton House candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/H4MA06090/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-seth-moulton-president": {
    id: "fec-seth-moulton-president",
    label: "Seth Moulton presidential candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/P00011866/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "campaign-john-deaton": {
    id: "campaign-john-deaton",
    label: "John Deaton for U.S. Senate",
    publisher: "John Deaton for Senate",
    kind: "campaign-controlled",
    authority: "self-reported",
    url: "https://www.johndeatonforsenate.com/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "campaign-bio-john-deaton": {
    id: "campaign-bio-john-deaton",
    label: "John Deaton campaign biography",
    publisher: "John Deaton for Senate",
    kind: "campaign-controlled",
    authority: "self-reported",
    url: "https://www.johndeatonforsenate.com/meet-john",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-john-deaton-2026": {
    id: "fec-john-deaton-2026",
    label: "John Deaton 2026 candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/S6MA00304/?cycle=2026",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "fec-john-deaton-2024": {
    id: "fec-john-deaton-2024",
    label: "John Deaton 2024 candidate record",
    publisher: "Federal Election Commission",
    kind: "finance-regulator",
    authority: "primary",
    url: "https://www.fec.gov/data/candidate/S4MA00358/",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
  "house-clerk-election-statistics-2024": {
    id: "house-clerk-election-statistics-2024",
    label: "Statistics of the Presidential and Congressional Election of November 5, 2024",
    publisher: "Office of the Clerk, U.S. House of Representatives",
    kind: "official-election",
    authority: "official-results-compilation",
    url: "https://clerk.house.gov/member_info/electionInfo/2024/statistics2024.pdf",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
  },
});

function citation(sourceId) {
  const source = senateProfileSources[sourceId];
  if (!source) throw new Error(`Unknown Senate profile source: ${sourceId}`);
  return Object.freeze({
    sourceId,
    url: source.url,
    checkedAt: source.checkedAt,
    reviewState: source.reviewState,
  });
}

function sourced(sourceId, value) {
  const evidence = citation(sourceId);
  return Object.freeze({
    ...value,
    ...(Array.isArray(value.options) ? {
      options: value.options.map((option) => Object.freeze({
        ...option,
        sourceId,
        sourceIds: [sourceId],
        citation: evidence,
      })),
    } : {}),
    sourceId,
    sourceIds: [sourceId],
    citation: evidence,
  });
}

const usSenateOffice = Object.freeze({
  id: "us-senate-massachusetts",
  label: "U.S. Senate",
  jurisdiction: "Massachusetts",
  district: "statewide",
});

const maHouseSixOffice = Object.freeze({
  id: "us-house-ma-06",
  label: "U.S. House · Massachusetts District 6",
  jurisdiction: "Massachusetts",
  district: "6",
});

export const senateCandidateProfileRecords = Object.freeze([
  {
    schemaVersion: "1.0.0",
    candidateId: "edward-markey",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
    identifiers: [
      sourced("house-history-edward-markey", {
        id: "edward-markey-bioguide",
        system: "bioguide",
        value: "M000133",
        scope: "congressional-person",
        current: true,
      }),
      sourced("fec-edward-markey-2026", {
        id: "edward-markey-fec-candidate",
        system: "fec-candidate",
        value: "S4MA00028",
        scope: "2026 U.S. Senate candidacy",
        current: true,
      }),
      sourced("fec-edward-markey-2026", {
        id: "edward-markey-fec-committee",
        system: "fec-committee",
        value: "C00196774",
        scope: "principal campaign committee",
        current: true,
      }),
    ],
    links: [
      sourced("senate-office-edward-markey", {
        id: "edward-markey-official-office",
        label: "Official Senate office",
        kind: "official-government",
        url: senateProfileSources["senate-office-edward-markey"].url,
      }),
      sourced("campaign-edward-markey", {
        id: "edward-markey-campaign",
        label: "Campaign website",
        kind: "campaign-controlled",
        url: senateProfileSources["campaign-edward-markey"].url,
      }),
      sourced("house-history-edward-markey", {
        id: "edward-markey-congressional-biography",
        label: "Congressional biography",
        kind: "official-government",
        url: senateProfileSources["house-history-edward-markey"].url,
      }),
      sourced("fec-edward-markey-2026", {
        id: "edward-markey-fec",
        label: "FEC candidate record",
        kind: "finance-regulator",
        url: senateProfileSources["fec-edward-markey-2026"].url,
      }),
    ],
    facts: [
      sourced("house-history-edward-markey", {
        id: "edward-markey-current-office",
        label: "Current public office",
        value: "United States Senator from Massachusetts",
        status: "available",
      }),
      sourced("house-history-edward-markey", {
        id: "edward-markey-congressional-service",
        label: "Congressional service",
        value: "U.S. House, 1976–2013; U.S. Senate, 2013–present",
        status: "available",
      }),
    ],
    careerTimeline: [
      sourced("house-history-edward-markey", {
        id: "edward-markey-ma-house",
        title: "Massachusetts state representative",
        organization: "Massachusetts House of Representatives",
        category: "public-office",
        period: { start: "1973", end: "1976", precision: "year" },
        description: "Served in the Massachusetts House of Representatives.",
        evidenceKind: "official-government",
        status: "available",
      }),
      sourced("house-history-edward-markey", {
        id: "edward-markey-us-house",
        title: "United States representative",
        organization: "U.S. House of Representatives",
        category: "public-office",
        period: { start: "1976-11-02", end: "2013-07-15", precision: "day" },
        description: "Served in the House until resigning to become a U.S. senator.",
        evidenceKind: "official-government",
        status: "available",
      }),
      sourced("house-history-edward-markey", {
        id: "edward-markey-us-senate",
        title: "United States senator",
        organization: "United States Senate",
        category: "public-office",
        period: { start: "2013-07-16", end: null, precision: "day" },
        description: "Took the oath after winning the June 25, 2013 special election; reelected in 2014 and 2020.",
        evidenceKind: "official-government",
        status: "available",
      }),
    ],
    electionHistory: [
      sourced("fec-federal-elections-2014", {
        id: "edward-markey-2014-general",
        date: "2014-11-04",
        stage: "general",
        office: usSenateOffice,
        candidateOptionId: "edward-markey",
        outcome: "won",
        options: [
          { id: "edward-markey", label: "Edward J. Markey", party: "Democratic", votes: 1289944, kind: "candidate", countsTowardShare: true },
          { id: "brian-herr", label: "Brian Herr", party: "Republican", votes: 791950, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: null, votes: 3078, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 2084972, blankBallots: null, ballotsCast: null },
        comparability: {
          status: "same-office-different-stage",
          note: "Same statewide office, but a general election is not directly comparable to the 2026 party primary.",
        },
      }),
      sourced("fec-federal-elections-2020", {
        id: "edward-markey-2020-primary",
        date: "2020-09-01",
        stage: "primary",
        office: usSenateOffice,
        candidateOptionId: "edward-markey",
        outcome: "won",
        options: [
          { id: "edward-markey", label: "Edward J. Markey", party: "Democratic", votes: 782694, kind: "candidate", countsTowardShare: true },
          { id: "joseph-kennedy", label: "Joseph P. Kennedy III", party: "Democratic", votes: 629359, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: "Democratic write-in", votes: 1935, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 1413988, blankBallots: null, ballotsCast: null },
        comparability: {
          status: "same-office-same-stage",
          note: "Same office and primary stage, but a different year, opponent field, electorate, and political context.",
        },
      }),
      sourced("fec-federal-elections-2020", {
        id: "edward-markey-2020-general",
        date: "2020-11-03",
        stage: "general",
        office: usSenateOffice,
        candidateOptionId: "edward-markey",
        outcome: "won",
        options: [
          { id: "edward-markey", label: "Edward J. Markey", party: "Democratic", votes: 2357809, kind: "candidate", countsTowardShare: true },
          { id: "kevin-oconnor", label: "Kevin J. O'Connor", party: "Republican", votes: 1177765, kind: "candidate", countsTowardShare: true },
          { id: "shiva-ayyadurai", label: "Shiva Ayyadurai", party: "Write-in", votes: 21134, kind: "write-in", countsTowardShare: true },
          { id: "all-others", label: "All others", party: null, votes: 7428, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 3564136, blankBallots: null, ballotsCast: null },
        comparability: {
          status: "same-office-different-stage",
          note: "Same statewide office, but a general election is not directly comparable to the 2026 party primary.",
        },
      }),
    ],
    gaps: [
      {
        id: "edward-markey-older-election-history",
        kind: "election-history",
        status: "not-imported",
        note: "Earlier House and the 2013 special-election results are not included in this bounded first slice.",
        reviewState: "explicit-gap",
      },
    ],
  },
  {
    schemaVersion: "1.0.0",
    candidateId: "seth-moulton",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
    identifiers: [
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-bioguide",
        system: "bioguide",
        value: "M001196",
        scope: "congressional-person",
        current: true,
      }),
      sourced("fec-seth-moulton-senate-2026", {
        id: "seth-moulton-fec-senate",
        system: "fec-candidate",
        value: "S6MA00296",
        scope: "2026 U.S. Senate candidacy",
        current: true,
      }),
      sourced("fec-seth-moulton-house", {
        id: "seth-moulton-fec-house",
        system: "fec-candidate",
        value: "H4MA06090",
        scope: "U.S. House candidacies",
        current: false,
      }),
      sourced("fec-seth-moulton-president", {
        id: "seth-moulton-fec-president",
        system: "fec-candidate",
        value: "P00011866",
        scope: "2020 presidential candidacy",
        current: false,
      }),
      sourced("fec-seth-moulton-senate-2026", {
        id: "seth-moulton-fec-committee",
        system: "fec-committee",
        value: "C00547240",
        scope: "principal campaign committee",
        current: true,
      }),
    ],
    links: [
      sourced("house-office-seth-moulton", {
        id: "seth-moulton-official-office",
        label: "Official House office",
        kind: "official-government",
        url: senateProfileSources["house-office-seth-moulton"].url,
      }),
      sourced("campaign-seth-moulton", {
        id: "seth-moulton-campaign",
        label: "Campaign website",
        kind: "campaign-controlled",
        url: senateProfileSources["campaign-seth-moulton"].url,
      }),
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-congressional-biography",
        label: "Congressional biography",
        kind: "official-government",
        url: senateProfileSources["house-history-seth-moulton"].url,
      }),
      sourced("fec-seth-moulton-senate-2026", {
        id: "seth-moulton-fec",
        label: "FEC Senate candidate record",
        kind: "finance-regulator",
        url: senateProfileSources["fec-seth-moulton-senate-2026"].url,
      }),
    ],
    facts: [
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-current-office",
        label: "Current public office",
        value: "United States Representative for Massachusetts District 6",
        status: "available",
      }),
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-military-service",
        label: "Military service",
        value: "United States Marine Corps, 2002–2008",
        status: "available",
      }),
    ],
    careerTimeline: [
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-marine-corps",
        title: "United States Marine",
        organization: "United States Marine Corps",
        category: "military-service",
        period: { start: "2002", end: "2008", precision: "year" },
        description: "The congressional biography records Marine Corps service from 2002 through 2008.",
        evidenceKind: "official-government",
        status: "available",
      }),
      sourced("house-history-seth-moulton", {
        id: "seth-moulton-us-house",
        title: "United States representative",
        organization: "U.S. House of Representatives",
        category: "public-office",
        period: { start: "2015-01-03", end: null, precision: "day" },
        description: "Represents Massachusetts District 6; first elected in 2014.",
        evidenceKind: "official-government",
        status: "available",
      }),
      sourced("fec-seth-moulton-president", {
        id: "seth-moulton-presidential-candidacy",
        title: "Presidential candidate",
        organization: "Federal Election Commission record",
        category: "candidacy",
        period: { start: "2019-05-07", end: "2020", precision: "mixed" },
        description: "FEC candidate record for the 2020 presidential election; no primary vote result is represented here.",
        evidenceKind: "finance-regulator",
        status: "available",
      }),
    ],
    electionHistory: [
      sourced("fec-federal-elections-2014", {
        id: "seth-moulton-2014-primary",
        date: "2014-09-09",
        stage: "primary",
        office: maHouseSixOffice,
        candidateOptionId: "seth-moulton",
        outcome: "won",
        options: [
          { id: "seth-moulton", label: "Seth W. Moulton", party: "Democratic", votes: 36575, kind: "candidate", countsTowardShare: true },
          { id: "john-tierney", label: "John F. Tierney", party: "Democratic", votes: 28915, kind: "candidate", countsTowardShare: true },
          { id: "marisa-defranco", label: "Marisa A. DeFranco", party: "Democratic", votes: 4293, kind: "candidate", countsTowardShare: true },
          { id: "john-devine", label: "John Patrick Devine", party: "Democratic", votes: 1527, kind: "candidate", countsTowardShare: true },
          { id: "john-gutta", label: "John J. Gutta", party: "Democratic", votes: 691, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: "Democratic write-in", votes: 36, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 72037, blankBallots: null, ballotsCast: null },
        comparability: {
          status: "different-office",
          note: "This was a district-level House primary, not a statewide Senate primary.",
        },
      }),
      sourced("fec-federal-elections-2014", {
        id: "seth-moulton-2014-general",
        date: "2014-11-04",
        stage: "general",
        office: maHouseSixOffice,
        candidateOptionId: "seth-moulton",
        outcome: "won",
        options: [
          { id: "seth-moulton", label: "Seth W. Moulton", party: "Democratic", votes: 149638, kind: "candidate", countsTowardShare: true },
          { id: "richard-tisei", label: "Richard R. Tisei", party: "Republican", votes: 111989, kind: "candidate", countsTowardShare: true },
          { id: "christopher-stockwell", label: "Christopher J. Stockwell", party: "Independent", votes: 10373, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: null, votes: 219, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 272219, blankBallots: null, ballotsCast: null },
        comparability: {
          status: "different-office",
          note: "This was a district-level House general election, not a statewide Senate primary.",
        },
      }),
      sourced("house-clerk-election-statistics-2024", {
        id: "seth-moulton-2024-general",
        date: "2024-11-05",
        stage: "general",
        office: maHouseSixOffice,
        candidateOptionId: "seth-moulton",
        outcome: "won",
        options: [
          { id: "seth-moulton", label: "Seth Moulton", party: "Democratic", votes: 321186, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: null, votes: 7191, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 328377, blankBallots: 110196, ballotsCast: 438573 },
        comparability: {
          status: "different-office-uncontested",
          note: "This was an uncontested district-level House general election with no named opposing candidate; it is not comparable to a contested statewide Senate primary.",
        },
      }),
    ],
    gaps: [
      {
        id: "seth-moulton-intervening-house-results",
        kind: "election-history",
        status: "not-imported",
        note: "This bounded slice shows the first and most recent House general elections, not every reelection.",
        reviewState: "explicit-gap",
      },
    ],
  },
  {
    schemaVersion: "1.0.0",
    candidateId: "john-deaton",
    checkedAt: CHECKED_AT,
    reviewState: REVIEW_STATE,
    identifiers: [
      sourced("fec-john-deaton-2026", {
        id: "john-deaton-fec-candidate-2026",
        system: "fec-candidate",
        value: "S6MA00304",
        scope: "2026 U.S. Senate candidacy",
        current: true,
      }),
      sourced("fec-john-deaton-2024", {
        id: "john-deaton-fec-candidate-2024",
        system: "fec-candidate",
        value: "S4MA00358",
        scope: "2024 U.S. Senate candidacy",
        current: false,
      }),
      sourced("fec-john-deaton-2026", {
        id: "john-deaton-fec-committee-2026",
        system: "fec-committee",
        value: "C00926139",
        scope: "2026 principal campaign committee",
        current: true,
      }),
      sourced("fec-john-deaton-2024", {
        id: "john-deaton-fec-committee-2024",
        system: "fec-committee",
        value: "C00870337",
        scope: "2024 principal campaign committee",
        current: false,
      }),
    ],
    links: [
      sourced("campaign-john-deaton", {
        id: "john-deaton-campaign",
        label: "Campaign website",
        kind: "campaign-controlled",
        url: senateProfileSources["campaign-john-deaton"].url,
      }),
      sourced("campaign-bio-john-deaton", {
        id: "john-deaton-campaign-biography",
        label: "Campaign biography",
        kind: "campaign-controlled",
        url: senateProfileSources["campaign-bio-john-deaton"].url,
      }),
      sourced("fec-john-deaton-2026", {
        id: "john-deaton-fec",
        label: "FEC candidate record",
        kind: "finance-regulator",
        url: senateProfileSources["fec-john-deaton-2026"].url,
      }),
    ],
    facts: [
      sourced("campaign-bio-john-deaton", {
        id: "john-deaton-occupation",
        label: "Campaign-described work",
        value: "Trial attorney",
        detail: "Candidate-controlled biography; not an independent characterization.",
        status: "available",
      }),
      sourced("campaign-bio-john-deaton", {
        id: "john-deaton-military-service",
        label: "Campaign-described military service",
        value: "United States Marine Corps, commissioned in 1994 and medically retired in 2002",
        detail: "Candidate-controlled biography; not independently verified in this slice.",
        status: "partial",
      }),
    ],
    careerTimeline: [
      sourced("campaign-bio-john-deaton", {
        id: "john-deaton-marine-corps",
        title: "United States Marine",
        organization: "United States Marine Corps",
        category: "military-service",
        period: { start: "1994", end: "2002", precision: "year" },
        description: "The candidate-controlled biography says he was commissioned in 1994 and medically retired in 2002.",
        evidenceKind: "campaign-controlled",
        status: "partial",
      }),
      sourced("campaign-bio-john-deaton", {
        id: "john-deaton-law-practice",
        title: "Founder and trial attorney",
        organization: "Private law practice",
        category: "private-career",
        period: { start: "2006", end: null, precision: "year" },
        description: "The candidate-controlled biography says he founded his law practice in 2006.",
        evidenceKind: "campaign-controlled",
        status: "partial",
      }),
      sourced("fec-john-deaton-2024", {
        id: "john-deaton-2024-candidacy",
        title: "U.S. Senate candidate",
        organization: "Federal Election Commission record",
        category: "candidacy",
        period: { start: "2024-02-27", end: "2024-11-05", precision: "day" },
        description: "FEC filing and official general-election result for the 2024 Massachusetts Senate contest.",
        evidenceKind: "finance-regulator",
        status: "available",
      }),
      sourced("fec-john-deaton-2026", {
        id: "john-deaton-2026-candidacy",
        title: "U.S. Senate candidate",
        organization: "Federal Election Commission record",
        category: "candidacy",
        period: { start: "2025-11-10", end: null, precision: "day" },
        description: "Current FEC record for the 2026 Massachusetts Senate contest.",
        evidenceKind: "finance-regulator",
        status: "available",
      }),
    ],
    electionHistory: [
      sourced("house-clerk-election-statistics-2024", {
        id: "john-deaton-2024-general",
        date: "2024-11-05",
        stage: "general",
        office: usSenateOffice,
        candidateOptionId: "john-deaton",
        outcome: "lost",
        options: [
          { id: "elizabeth-warren", label: "Elizabeth Warren", party: "Democratic", votes: 2041668, kind: "candidate", countsTowardShare: true },
          { id: "john-deaton", label: "John Deaton", party: "Republican", votes: 1365440, kind: "candidate", countsTowardShare: true },
          { id: "all-others", label: "All others", party: null, votes: 6221, kind: "all-others", countsTowardShare: true },
        ],
        totals: { candidateVotePool: 3413329, blankBallots: 99601, ballotsCast: 3512930 },
        comparability: {
          status: "same-office-different-stage",
          note: "Same statewide office, but a general election is not directly comparable to the 2026 party primary.",
        },
      }),
    ],
    gaps: [
      {
        id: "john-deaton-no-congressional-id",
        kind: "identifier",
        status: "not-applicable",
        note: "No Bioguide identifier is recorded because this profile does not identify prior service in Congress.",
        reviewState: "explicit-gap",
      },
      {
        id: "john-deaton-2024-primary",
        kind: "election-history",
        status: "manual-review-required",
        note: "The 2024 Republican primary result is intentionally not imported from Massachusetts Secretary pages; project policy requires a permitted export or maintainer-reviewed citation.",
        reviewState: "explicit-gap",
      },
      {
        id: "john-deaton-independent-career-verification",
        kind: "career-history",
        status: "not-researched",
        note: "The non-campaign verification pass for private-sector and military biography details remains open.",
        reviewState: "explicit-gap",
      },
    ],
  },
]);

export const senateCandidateProfilesById = Object.freeze(Object.fromEntries(
  senateCandidateProfileRecords.map((profile) => [profile.candidateId, profile]),
));
